import Config from './Config.js';
import LocaleManager from './LocaleManager.js';
import SoundManager from './SoundManager';
import Server from '../services/Server';
import utils from './Utils.js';

export default class Preloader {

    preload()
    {
        // Start the preloadinbg process
        //leanderGMApi.publishEvent(leanderGMApi.publications.PRELOADING_STARTED);

        this.ASSETS_ROOT = Config.MobileDevice ? 'assets/mobile' : 'assets/desktop';

        LocaleManager.init(this.load, Config.locale);
        this.loadImages();
        this.loadSpritesheets();
        this.loadAudio();
        this.loadIntro();
    }

    loadInitData()
    {
        if (Config.initData)
        {
            return Promise.resolve();
        }

        const server = new Server(leanderGMApi);
        return server.init().then((resp) =>
        {
            Config.initData = resp;
            return Promise.resolve();
        }).catch((err) =>
        {
            console.error('Init Error:', err);
            return Promise.reject();
        });
    }

    loadAudio()
    {
        let config = require('../../assets/audio/config.json');
        let soundsRoot = 'assets/audio/';

        for (let key in config.sounds)
        {
            let url = config.sounds[key];
            this.load.audio(
                `sounds/${key}`,
                `${soundsRoot}${url}`
            ).onFileComplete.add(this.loadLeanderPrelodader, this);
        }

        for (let key in config.music)
        {
            let url = config.music[key];
            this.load.audio(
                `music/${key}`,
                `${soundsRoot}${url}`
            ).onFileComplete.add(this.loadLeanderPrelodader, this);
        }
    }

    loadLeanderPrelodader(progress, file, success)
    {
        // Publish the status
        leanderGMApi.publishEvent(leanderGMApi.publications.PRELOADING_PROGRESS_UPDATED, progress);
        
        // If progress is completed, publish it.
        if (progress === 100)
        {
            this.loadInitData().then(() =>
            {
                leanderGMApi.publishEvent(leanderGMApi.publications.PRELOADING_ENDED);
            });
        }
    }

    loadImages()
    {
        // common
        [
            { key: 'panels.more-less-bg', path: '/panels/more-less-panel-bg.png' },
            { key: 'panels.more-less-bg-long', path: '/panels/more-less-panel-bg-long.png' }
        ].forEach((image) =>
        {
            this.load.image(
                image.key,
                `${this.ASSETS_ROOT}${image.path}`
            ).onFileComplete.add(this.loadLeanderPrelodader, this);
        });

        // commons independent from layout
        this.load.image(
            'popups.common.close',
            'assets/common/popups/close.png'
        ).onFileComplete.add(this.loadLeanderPrelodader, this);
        this.load.image(
            'panels.bonus-win.bg',
            'assets/common/panels/bonus-win-panel-bg.png'
        ).onFileComplete.add(this.loadLeanderPrelodader, this);

        const langPostfix = ['en', 'tr'].indexOf(LocaleManager.locale) !== -1 ? LocaleManager.locale : 'en';
        this.load.image(
            'footer.logo',
            `assets/common/panels/footer-logo-${langPostfix}.png`
        ).onFileComplete.add(this.loadLeanderPrelodader, this);
        this.load.image(
            'logo',
            `assets/common/logo-${langPostfix}.png`
        ).onFileComplete.add(this.loadLeanderPrelodader, this);

        console.info('Config.START_ORIENTATION', Config.START_ORIENTATION);

        if (Config.MobileDevice)
        {
            // mobile
            [
                { key: 'game_background', path: Config.START_ORIENTATION === Config.PORTRAIT ?
                    '/game_bg_portrait.jpg' : '/game_bg.jpg' },
                { key: 'game_background_ornament', path: Config.START_ORIENTATION === Config.PORTRAIT ?
                    '/game_bg_ornament_portrait.png' : '/game_bg_ornament.png' },
                { key: 'game_bonus_background', path: Config.START_ORIENTATION === Config.PORTRAIT ?
                    '/game_bonus_bg_portrait.jpg' : '/game_bonus_bg.jpg' },
                { key: 'panels.win-bg', path: Config.START_ORIENTATION === Config.PORTRAIT ?
                    '/panels/win-panel-bg-portrait.png' : '/panels/win-panel-bg.png' },
                { key: 'panels.footer-money-bg', path: '/panels/footer-money-panel-bg.png' },
                { key: 'panels.footer-bg', path: '/panels/footer-panel-bg.jpg' },
                { key: 'panels.debug', path: '/buttons/debug-panel.png' },

                { key: 'slot.bg', path: '/slot/bg.png' },
                { key: 'slot.symbols-mix-1', path: '/slot/symbols_reel_mix1_blur.png' },
                { key: 'slot.symbols-mix-2', path: '/slot/symbols_reel_mix2_blur.png' },
                { key: 'slot.symbols-mix-3', path: '/slot/symbols_reel_mix3_blur.png' },
                { key: 'slot.symbols-mix-4', path: '/slot/symbols_reel_mix4_blur.png' },
                { key: 'slot.symbols-mix-5', path: '/slot/symbols_reel_mix5_blur.png' },

                { key: 'popups.big-win.bg', path: Config.START_ORIENTATION === Config.PORTRAIT ?
                    '/popups/big-win/bg-portrait.png' : '/popups/big-win/bg.png' },
                { key: 'popups.big-win.star', path: '/popups/big-win/star.png' },

                { key: 'popups.bonus-spin.bg', path: Config.START_ORIENTATION === Config.PORTRAIT ?
                    '/popups/bonus-spin/bg-portrait.png' : '/popups/bonus-spin/bg.png' },

                { key: 'turn-to', path: Config.START_ORIENTATION === Config.PORTRAIT ?
                    '/turn-to-portrait.png' : '/turn-to-landscape.png' },

                { key: 'bonus-round-title', path: Config.START_ORIENTATION === Config.PORTRAIT ?
                    '/bonus_round_title_portrait.png' : '/bonus_round_title.png' }
            ].forEach((image) =>
            {
                this.load.image(
                    image.key,
                    `${this.ASSETS_ROOT}${image.path}`
                ).onFileComplete.add(this.loadLeanderPrelodader, this);
            });
        }
        else
        {
            // desktop
            [
                { key: 'game_background', path: '/game_bg.jpg' },
                { key: 'game_background_ornament', path: '/game_bg_ornament.png' },
                { key: 'game_bonus_background', path: '/game_bonus_bg.jpg' },
                { key: 'panels.win-bg', path: '/panels/win-panel-bg.png' },
                { key: 'panels.footer-money-bg', path: '/panels/footer-money-panel-bg.png' },
                { key: 'panels.footer-bg', path: '/panels/footer-panel-bg.jpg' },
                { key: 'panels.debug', path: '/buttons/debug-panel.png' },

                { key: 'slot.bg', path: '/slot/bg.png' },
                { key: 'slot.symbols-mix-1', path: '/slot/symbols_reel_mix1_blur.png' },
                { key: 'slot.symbols-mix-2', path: '/slot/symbols_reel_mix2_blur.png' },
                { key: 'slot.symbols-mix-3', path: '/slot/symbols_reel_mix3_blur.png' },
                { key: 'slot.symbols-mix-4', path: '/slot/symbols_reel_mix4_blur.png' },
                { key: 'slot.symbols-mix-5', path: '/slot/symbols_reel_mix5_blur.png' },

                { key: 'popups.big-win.bg', path: '/popups/big-win/bg.png' },
                { key: 'popups.big-win.star', path: '/popups/big-win/star.png' },

                { key: 'popups.bonus-spin.bg', path: '/popups/bonus-spin/bg.png' },
                { key: 'bonus-round-title', path: '/bonus_round_title.png' }
            ].forEach((image) =>
            {
                this.load.image(
                    image.key,
                    `${this.ASSETS_ROOT}${image.path}`
                ).onFileComplete.add(this.loadLeanderPrelodader, this);
            });
        }
    }

    loadSpritesheets()
    {
        // common
        [
            { key: 'buttons.checkbox', path: '/buttons/checkbox.png', restParams: [71, 30] }
        ].forEach((image) =>
        {
            this.load.spritesheet(
                image.key,
                `${this.ASSETS_ROOT}${image.path}`,
                image.restParams[0],
                image.restParams[1]
            ).onFileComplete.add(this.loadLeanderPrelodader, this);
        });

        if (Config.layout === Config.DESKTOP)
        {
            // DESKTOP
            [
                { key: 'buttons.help', path: '/buttons/help.png', restParams: [90, 90] },
                { key: 'buttons.home', path: '/buttons/home.png', restParams: [90, 90] },
                { key: 'buttons.minus', path: '/buttons/minus.png', restParams: [90, 90] },
                { key: 'buttons.plus', path: '/buttons/plus.png', restParams: [90, 90] },
                { key: 'buttons.accept', path: '/buttons/accept.png', restParams: [120, 120] },

                { key: 'buttons.pause', path: '/buttons/pause.png', restParams: [169, 169] },
                { key: 'buttons.play', path: '/buttons/play.png', restParams: [169, 169] },
                { key: 'buttons.settings', path: '/buttons/sound.png', restParams: [90, 90] }
            ].forEach((image) =>
            {
                this.load.spritesheet(
                    image.key,
                    `${this.ASSETS_ROOT}${image.path}`,
                    image.restParams[0],
                    image.restParams[1]
                ).onFileComplete.add(this.loadLeanderPrelodader, this);
            });

            // Symbols animations
            [
                'bonus', 'diamond', 'glasses',
                'microphone', 'raki', 'ring', 'teshib',
                'old', 'guy', 'singer',
                'old_extra', 'guy_extra', 'singer_extra'
            ].forEach((symbol) =>
            {
                this.load.atlas(
                    `slot-symbol-${symbol}`,
                    `${this.ASSETS_ROOT}/slot/symbols/${symbol}.png`,
                    `${this.ASSETS_ROOT}/slot/symbols/${symbol}.json`,
                    Phaser.Loader.TEXTURE_ATLAS_JSON_HASH
                ).onFileComplete.add(this.loadLeanderPrelodader, this);
            });

            // Slot bonus frame animation
            this.load.atlas(
                'bonus_frame_animation',
                `${this.ASSETS_ROOT}/slot/bonus_frame_animation.png`,
                `${this.ASSETS_ROOT}/slot/bonus_frame_animation.json`,
                Phaser.Loader.TEXTURE_ATLAS_JSON_HASH
            ).onFileComplete.add(this.loadLeanderPrelodader, this);
        }
        else
        {
            // MOBILE
            [
                { key: 'buttons.help', path: '/buttons/help.png', restParams: [60, 60] },
                { key: 'buttons.home', path: '/buttons/home.png', restParams: [60, 60] },
                { key: 'buttons.minus', path: '/buttons/minus.png', restParams: [62, 60] },
                { key: 'buttons.plus', path: '/buttons/plus.png', restParams: [62, 60] },
                { key: 'buttons.accept', path: '/buttons/accept.png', restParams: [120, 120] },

                { key: 'buttons.pause', path: '/buttons/pause.png', restParams: [139, 139] },
                { key: 'buttons.play', path: '/buttons/play.png', restParams: [140, 139] },
                { key: 'buttons.menu', path: '/buttons/menu.png', restParams: [67, 67] }
            ].forEach((image) =>
            {
                this.load.spritesheet(
                    image.key,
                    `${this.ASSETS_ROOT}${image.path}`,
                    image.restParams[0],
                    image.restParams[1]
                ).onFileComplete.add(this.loadLeanderPrelodader, this);
            });

            // Animations
            [
                'bonus', 'diamond', 'glasses',
                'microphone', 'raki', 'ring', 'teshib',
                'old', 'guy', 'singer',
                'old_extra', 'guy_extra', 'singer_extra'
            ].forEach((symbol) =>
            {
                this.load.atlas(
                    `slot-symbol-${symbol}`,
                    `${this.ASSETS_ROOT}/slot/symbols/${symbol}.png`,
                    `${this.ASSETS_ROOT}/slot/symbols/${symbol}.json`,
                    Phaser.Loader.TEXTURE_ATLAS_JSON_HASH
                ).onFileComplete.add(this.loadLeanderPrelodader, this);
            });

            // Slot bonus frame animation
            this.load.atlas(
                'bonus_frame_animation',
                `${this.ASSETS_ROOT}/slot/bonus_frame_animation.png`,
                `${this.ASSETS_ROOT}/slot/bonus_frame_animation.json`,
                Phaser.Loader.TEXTURE_ATLAS_JSON_HASH
            ).onFileComplete.add(this.loadLeanderPrelodader, this);
        }
    }

    loadIntro()
    {
        const slideLangPostfix = ['en', 'tr'].indexOf(LocaleManager.locale) !== -1 ? LocaleManager.locale : 'en';
        [
            { key: 'intro.slide1', path: `/intro/slide1-${slideLangPostfix}.png` },
            { key: 'intro.slide2', path: `/intro/slide2-${slideLangPostfix}.png` },
            { key: 'intro.slide3', path: `/intro/slide3-${slideLangPostfix}.png` },
            { key: 'intro.arrow-left', path: '/intro/arrow-left.png' },
            { key: 'intro.arrow-right', path: '/intro/arrow-right.png' }
        ].forEach((image) =>
        {
            this.load.image(
                image.key,
                `${this.ASSETS_ROOT}${image.path}`
            ).onFileComplete.add(this.loadLeanderPrelodader, this);
        });

        this.load.audio(
            'music/intro-music',
            'assets/audio/music/intro-music.mp3'
        ).onFileComplete.add(this.loadLeanderPrelodader, this);
    }

    create()
    {
        SoundManager.init(this.game, {
            sound: leanderGMApi && typeof leanderGMApi.getSfxActive === 'function' ? leanderGMApi.getSfxActive() : Config.soundEnabled,
            soundVolume: Config.soundVolume,
            music: leanderGMApi && typeof leanderGMApi.getMusicActive  === 'function' ? leanderGMApi.getMusicActive() : Config.musicEnabled,
            musicVolume: Config.musicVolume
        });

        this.state.start('Intro');
        //this.state.start('Game');
    }
}